<template>
    <div class="page_content">
        <h1 class="head_title">实习管理</h1>
        <div v-loading="loading">
            <template v-if="internshipInfo">
                <el-card class="info_card" shadow="hover">
                    <div slot="header" class="card_header">
                        <span class="title">{{ internshipInfo.internshipTitle }}</span>
                    </div>
                    <div class="info_list">
                        <div class="info_item">
                            <span class="label">年级：</span>
                            <span class="value">{{ internshipInfo.grade }}</span>
                        </div>
                        <div class="info_item">
                            <span class="label">添加时间：</span>
                            <span class="value">{{ formatTime(internshipInfo.internshipAddTime) }}</span>
                        </div>
                        <div class="info_item">
                            <span class="label">状态：</span>
                            <span class="value">
                                <el-tag :type="internshipInfo.internshipStatus == 1 ? 'success' : 'info'" size="small">
                                    {{ internshipInfo.internshipStatus == 1 ? '正常' : '已删除' }}
                                </el-tag>
                            </span>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <div class="file_list">
                        <div class="file_item">
                            <span class="label">实习要求：</span>
                            <el-button type="text" icon="el-icon-document" @click="previewFile(internshipInfo.internshipRequire, '实习要求')"
                                v-if="!$isEmpty(internshipInfo.internshipRequire)">查看文件</el-button>
                            <span class="value" v-else>暂无</span>
                        </div>
                        <div class="file_item">
                            <span class="label">实习鉴定表模板：</span>
                            <el-button type="text" icon="el-icon-document" @click="previewFile(internshipInfo.internshipEvaluationFormTemplate, '实习鉴定表模板')"
                                v-if="!$isEmpty(internshipInfo.internshipEvaluationFormTemplate)">查看文件</el-button>
                            <span class="value" v-else>暂无</span>
                        </div>
                    </div>
                </el-card>
            </template>
            <el-empty v-else-if="!loading" description="暂无实习信息"></el-empty>
        </div>

        <!-- 提交记录 -->
        <div class="record_section" v-if="internshipInfo">
            <div class="section_header">
                <h2 class="section_title">提交记录</h2>
                <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog" :disabled="isUploadDisabled">上传鉴定表</el-button>
            </div>
            <el-table :data="recordList" v-loading="recordLoading" border style="width: 100%">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column label="附件" min-width="200">
                    <template slot-scope="scope">
                        <div v-if="!$isEmpty(scope.row.approveFileUrls)">
                            <el-button type="text" icon="el-icon-document"
                                v-for="(url, idx) in scope.row.approveFileUrls.split(',')" :key="idx"
                                @click="previewFile(url, '附件' + (idx + 1))">
                                附件{{ idx + 1 }}
                            </el-button>
                        </div>
                        <span v-else>暂无</span>
                    </template>
                </el-table-column>
                <el-table-column label="确认状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.confirmStatus == 1 ? 'success' : 'warning'" size="small">
                            {{ scope.row.confirmStatus == 1 ? '已确认' : '未确认' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="确认时间" width="160" align="center">
                    <template slot-scope="scope">
                        {{ formatTime(scope.row.confirmTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="说明" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ $isEmpty(scope.row.remark) ? '暂无' : scope.row.remark }}
                    </template>
                </el-table-column>
                <el-table-column label="提交时间" width="160" align="center">
                    <template slot-scope="scope">
                        {{ formatTime(scope.row.internshipEvaluationFormAddTime) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 上传鉴定表对话框 -->
        <el-dialog title="提交实习鉴定表" :visible.sync="uploadDialogVisible" width="500px" @close="resetUploadForm">
            <el-form label-width="100px">
                <el-form-item label="附件：">
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="headers"
                        :accept="accept"
                        :on-success="handleUploadSuccess"
                        :on-remove="handleUploadRemove"
                        :before-upload="beforeUpload"
                        :file-list="uploadFileList"
                        multiple>
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传<span style="color: red;"> pdf </span>文件，支持多文件上传，单个文件不超过50MB</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitEvaluationForm" :loading="submitLoading">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getCookieForRoleTag } from '@/common/ulit';
    export default {
        name: "InternshipManagement",
        data() {
            return {
                loading: false,
                internshipInfo: null,
                recordLoading: false,
                recordList: [],
                uploadDialogVisible: false,
                submitLoading: false,
                uploadUrl: this.$baseUrl + "/api/file/update.do",
                headers: {
                    token: getCookieForRoleTag(),
                    "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null
                },
                uploadFileList: [],
                approveFileUrls: '',
                accept:".pdf"
            };
        },
        computed: {
            isUploadDisabled() {
                return this.recordList.length === 1 && this.recordList[0].confirmStatus === 1;
            }
        },
        created() {
            this.getInternshipInfo();
        },
        mounted() {

        },
        methods: {
            getInternshipInfo() {
                this.loading = true;
                this.$store.dispatch("user/getInternshipInfo").then((ret) => {
                    this.loading = false;
                    if (ret.code == 0 || ret.code == "0") {
                        this.internshipInfo = ret.data;
                        if (ret.data) {
                            this.getRecordList();
                        }
                    }
                }).catch(() => {
                    this.loading = false;
                });
            },
            getRecordList() {
                this.recordLoading = true;
                this.$store.dispatch("user/getInternshipEvaluationFormList").then((ret) => {
                    this.recordLoading = false;
                    if (ret.code == 0 || ret.code == "0") {
                        this.recordList = ret.data || [];
                    }
                }).catch(() => {
                    this.recordLoading = false;
                });
            },
            openUploadDialog() {
                this.resetUploadForm();
                this.uploadDialogVisible = true;
            },
            resetUploadForm() {
                this.uploadFileList = [];
                this.approveFileUrls = '';
            },
            handleUploadSuccess(res, file) {
                if (res.code == 0 || res.code == "0") {
                    let fileUrl = res.data.url;
                    if (this.$isEmpty(this.approveFileUrls)) {
                        this.approveFileUrls = fileUrl;
                    } else {
                        this.approveFileUrls += ',' + fileUrl;
                    }
                    this.$message.success('文件上传成功');
                } else {
                    this.$message.error(res.msg || '文件上传失败');
                }
            },
            handleUploadRemove(file, fileList) {
                let urlToRemove = '';
                if (file.response && file.response.data) {
                    urlToRemove = file.response.data.url;
                } else if (file.url) {
                    urlToRemove = file.url;
                }
                if (urlToRemove && this.approveFileUrls) {
                    let urlArray = this.approveFileUrls.split(',');
                    let newUrlArray = urlArray.filter(url => url.trim() !== urlToRemove.trim());
                    this.approveFileUrls = newUrlArray.join(',');
                }
            },
            beforeUpload(file) {
                const isLt50M = file.size / 1024 / 1024 < 50;
                if (!isLt50M) {
                    this.$message.error('上传文件大小不能超过 50MB!');
                    return false;
                }
                if(!this.$isEmpty(this.accept)){
                    const fileName = file.name;
                    const fileType = fileName.substring(fileName.lastIndexOf('.'));
                    // jpeg,.png,.jpg,.bmp,.gif
                    if (this.accept.toUpperCase().indexOf(fileType.toUpperCase()) < 0) {
                    this.$message.warning("文件类型错误，请重新上传！")
                        return false;
                    }
               }
                return true;
            },
            submitEvaluationForm() {
                if (this.$isEmpty(this.approveFileUrls)) {
                    this.$message.warning('请先上传附件');
                    return;
                }
                let internshipId = this.internshipInfo.internshipId || this.internshipInfo.id;
                if (!internshipId) {
                    this.$message.warning('实习信息异常，无法提交');
                    return;
                }
                this.submitLoading = true;
                this.$store.dispatch("user/submitInternshipEvaluationForm", {
                    InternshipId: internshipId,
                    approveFileUrls: this.approveFileUrls
                }).then((ret) => {
                    this.submitLoading = false;
                    if (ret.code == 0 || ret.code == "0") {
                        this.$message.success('提交成功');
                        this.uploadDialogVisible = false;
                        this.getRecordList();
                    } else {
                        this.$message.error(ret.msg || '提交失败');
                    }
                }).catch(() => {
                    this.submitLoading = false;
                });
            },
            formatTime(time) {
                if (this.$isEmpty(time)) return '暂无';
                let date = new Date(time);
                let y = date.getFullYear();
                let m = (date.getMonth() + 1).toString().padStart(2, '0');
                let d = date.getDate().toString().padStart(2, '0');
                let h = date.getHours().toString().padStart(2, '0');
                let mi = date.getMinutes().toString().padStart(2, '0');
                return `${y}-${m}-${d} ${h}:${mi}`;
            },
            previewFile(url, name) {
                if (this.$isEmpty(url)) {
                    this.$message.warning('暂无文件');
                    return;
                }
                this.$downLoadFile(url, name);
            }
        }
    };
</script>

<style scoped lang="less">
    .page_content {
        background-color: white;
        // padding: 20px;
        border-radius: 5px;
        min-height: calc(100vh - 100px);
    }
    .head_title {
        font-size: 24px;
        margin-bottom: 30px;
    }
    .info_card {
        .card_header {
            .title {
                font-size: 18px;
                font-weight: bold;
            }
        }
    }
    .info_list {
        .info_item {
            margin-bottom: 15px;
            .label {
                color: #909399;
                display: inline-block;
                width: 100px;
            }
            .value {
                color: #303133;
            }
        }
    }
    .file_list {
        .file_item {
            margin-bottom: 15px;
            .label {
                color: #909399;
                display: inline-block;
                width: 130px;
            }
            .value {
                color: #909399;
            }
        }
    }
    .record_section {
        margin-top: 30px;
        .section_header {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;
            gap:20px;
        }
        .section_title {
            font-size: 18px;
            color: #303133;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/InternshipManagement.vue